<template>
    <section>
        <div class="loading-container">
            <div class="loading-spinner"></div>
            <p>Redirecting, please wait...</p>
        </div>
    </section>
</template>

<style scoped>
.loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
}

.loading-spinner {
    border: 16px solid #f3f3f3;
    border-top: 16px solid #3498db;
    border-radius: 50%;
    width: 120px;
    height: 120px;
    animation: spin 2s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>

<script>
export default {
    name: 'MemberRegister',
    created() {
        window.location.href = `${this.$root.$data.BASE_URL}/member-register`;
    }
}
</script>